import { IconCopy, IconRemovePost } from '@/assets';
import { copyClipboard } from '@/utils';
import moment from 'moment';
import React from 'react';
import { match } from 'ts-pattern';
import { API_COLUMNS_ID } from './constants';
import type { APIDataTable } from './helpers';

const APICell: React.FC<{
  data: APIDataTable;
  columnKey: React.Key;
  onOpenDel: (key: string) => void;
}> = ({ data, columnKey, onOpenDel }) => {
  const cellValue = data[columnKey as keyof APIDataTable];

  const hidenKey = (value: string) => '****************' + value.slice(-6);

  const renderCell = () => {
    return match(columnKey)
      .with(API_COLUMNS_ID.Key, () => (
        <div className="flex items-center gap-2">
          <span>{hidenKey(data.sk)}</span>
          <div onClick={(e) => copyClipboard(e, data.sk)} className="w-[36px] h-[36px] cursor-pointer rounded-full bg-[#F8F9FD] flex items-center justify-center">
            <IconCopy />
          </div>
        </div>
      ))
      .with(API_COLUMNS_ID.Name, () => (
        <div className="line-clamp-1 min-w-[80px]">{data.name}</div>
      ))
      .with(API_COLUMNS_ID.CreatedAt, () => (
        <span className="whitespace-nowrap">{moment(data.createdAt).format('ll')}</span>
      ))
      .with(API_COLUMNS_ID.Action, () => (
        <div onClick={() => onOpenDel(data.sk)} className="w-[40px] h-[40px] cursor-pointer rounded-full bg-[#F8F9FD] flex items-center justify-center">
          <IconRemovePost className="opacity-70 scale-80" />
        </div>
      ))
      .otherwise(() => <span>{cellValue}</span>);
  };

  return renderCell();
};

export default APICell;